import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/gdstd2.webp";
import { Col } from 'react-bootstrap';
import { renderTextBlock } from 'src/components/RenderTextBlocks';


export const projectDetails: ProjectInterface = {
    url: "gdstd2",
    title: "Gamedev Study 2",
    summary: "Prototype to experiment and study multiplayer and networking in Unity.",
    description: `When I started to get interested in multiplayer I did this experiment/study to test some solutions and learn about networking.`,
    year: "2021",
    tags: ["Prototype", "Multiplayer", "Study Project", "Unity"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: true,
    projectType: ProjectType.STUDY,
    haveTags: true,
    roles: ["Multiplayer Programmer", "Study"],
    technologies: ["Unity", "C#", "Multiplayer"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "My first dive into multiplayer game dev",
    linkData:
        [
            { type: 'github', url: "https://github.com/lucasctnh/gdstd-2-unity" },
            { type: 'text', url: "https://github.com/lucasctnh/gdstd-2-unity/releases" },
        ],
    relatedProjects: ["GDSTD3", "GDSTD4", "CheckMore"],
};


export function GDSTD2() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                isLeftFirst={false}
                leftContent={
                    <Col size={12} md={12} className="a-body-left" style={{ marginTop: "0" }}>
                        <div className="a-subtitle">
                            Afterthoughts
                        </div>

                        <div className="a-body-description">
                            {renderTextBlock(`Although I tested some other solutions, like [MLAPI](https://github.com/Unity-Technologies/com.unity.netcode.gameobjects) and [Forge Networking](https://github.com/BeardedManStudios/ForgeNetworkingRemastered), I kept using [Mirror](https://assetstore.unity.com/packages/tools/network/mirror-129321). My goal was to do something peer-to-peer (P2P) because I thought that way I wouldn't need to have a server, but I learned that the usual thing in P2P is to actually have a central server that helps the users connection with each other. Trying to do a decentralized P2P connection was way out of what I could do at the time.

Then I found [Noble Connect](https://assetstore.unity.com/packages/tools/network/noble-connect-free-141599), which is a cloud solution for doing the whole thing of keeping a relay server to help the connection of the users. I didn't really like to use an abstraction but I decided to learn things step by step, and learn how to create a relay server later.

One big mistake I made on this study though was that I overscoped. I tried to turn it into an actual game, a small one, but still, instead of keeping it a prototype. Because of that I lost track of the code and the project was a mess with everything I was testing, making work on the project very frustrating. ☹️`)}
                        </div>
                    </Col>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}